import { render, staticRenderFns } from "./UiMarkets.vue?vue&type=template&id=43f79697&"
import script from "./UiMarkets.vue?vue&type=script&lang=js&"
export * from "./UiMarkets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports